import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Textarea } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const MAX_DOCUMENTATION_NOTE_LENGTH = 2000;

export const documentationNoteTooLong = (note: string) => note.trim().length > MAX_DOCUMENTATION_NOTE_LENGTH;

export const DocumentationNoteField = ({
  note,
  onChange,
  mt,
}: {
  note: string;
  onChange: (note: string) => void;
  mt: string;
}) => {
  const { t } = useTranslation();
  const tooLong = documentationNoteTooLong(note);
  return (
    <FormControl mt={mt} isInvalid={tooLong}>
      <FormLabel fontSize="sm">{t("Note (optional)")}</FormLabel>
      <Textarea
        size="sm"
        rows={2}
        value={note}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("For example which documents you received and where they are kept") ?? undefined}
      />
      <FormHelperText>
        {t("{{count}} / {{max}} characters", { count: note.trim().length, max: MAX_DOCUMENTATION_NOTE_LENGTH })}
      </FormHelperText>
      <FormErrorMessage>
        {t("The note can be at most {{max}} characters.", { max: MAX_DOCUMENTATION_NOTE_LENGTH })}
      </FormErrorMessage>
    </FormControl>
  );
};
